import { render, staticRenderFns } from "./AgentProfilePopupInfo.vue?vue&type=template&id=bcae683c&scoped=true"
import script from "./AgentProfilePopupInfo.vue?vue&type=script&lang=ts"
export * from "./AgentProfilePopupInfo.vue?vue&type=script&lang=ts"
import style0 from "./AgentProfilePopupInfo.vue?vue&type=style&index=0&id=bcae683c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.23_css-loader@7.1.2_webpack@5.102.1__ejs@3.1.10_hand_7xqkb7dpji44cyfzinanhrbboy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcae683c",
  null
  
)

export default component.exports